module.exports = __webpack_public_path__ + "static/media/map.5515ccf4.png";